import { render, staticRenderFns } from "./ArticlesSection.vue?vue&type=template&id=9cdc730e&scoped=true"
import script from "./ArticlesSection.vue?vue&type=script&lang=js"
export * from "./ArticlesSection.vue?vue&type=script&lang=js"
import style0 from "./ArticlesSection.vue?vue&type=style&index=0&id=9cdc730e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdc730e",
  null
  
)

export default component.exports